import React from "react";
import styles from "../css/my.css";
import { Link } from "react-router-dom";
import { origin } from "../request";
import { request } from "../request";
import { checkToekn } from "../tools/wechatBrower";

const Item = ({ text, img, mode }) => {
  return (
    <div className={styles.item}>
      <img
        alt=""
        src={require("../static/" + img)}
        className={styles.itemImg}
      ></img>
      <span className={mode ? styles.itemText2 : styles.itemText}>{text}</span>
    </div>
  );
};

const Line = ({ leftText }) => {
  return (
    <div className={styles.lineItem}>
      <div className={styles.left}>
        <span className={styles.leftText}>{leftText}</span>
      </div>
      <div>
        <span
          className="iconfont icon-you"
          style={{ color: "#666666", fontSize: "14px" }}
        ></span>
      </div>
    </div>
  );
};

const Header = ({ phone }) => {
  return (
    <div className={styles.top}>
      <div style={{ marginTop: "1rem" }}>
        <div className={styles.topFirst}>
          <div className={styles.topLeft}>
            <img
              src={localStorage.getItem("head_image")}
              style={{
                width: "60px",
                height: "60px",
                borderRadius: "60px",
              }}
              alt=""
            ></img>
            <div className={styles.info}>
              <span
                style={{
                  color: "white",
                  fontSize: "16px",
                  paddingLeft: "15px",
                  marginTop: "7px",
                  marginBottom: "5px",
                }}
              >
                {localStorage.getItem("nickname")}
              </span>
              <div>
                <span
                  style={{
                    color: "white",
                    fontSize: "16px",
                    paddingLeft: "15px",
                    marginTop: "7px",
                    marginBottom: "5px",
                  }}
                >
                  {phone}
                </span>
              </div>
            </div>
          </div>

          <div>
            <img
              src={
                origin + "uploads/20210414/81eaa180b1be9016f7466d8e9c0e6b57.png"
              }
              style={{
                width: "32px",
              }}
              alt=""
            ></img>
          </div>
        </div>
        <div className={styles.topSecond}>
          <Link to="/info" style={{ color: "black" }}>
            <Item text="个人信息" img="个人信息.png" mode={true}></Item>
          </Link>

          <Link to="/receivingInformation/list" style={{ color: "black" }}>
            <div className={styles.item}>
              <img
                alt=""
                src={require("../static/收件信息.png")}
                className={styles.itemImg}
                style={{ width: "24px" }}
              ></img>
              <span className={styles.itemText2}>收件信息</span>
            </div>
          </Link>

          <Link to="/fp/list" style={{ color: "black" }}>
            <Item text="发票信息" img="发票信息.png" mode={true}></Item>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default class extends React.Component {
  state = {
    phone: "",
  };

  async componentDidMount() {
    let res = await checkToekn();
    if (res) {
      request(
        "index/getInfo",
        {
          uid: localStorage.getItem("openid"),
        },
        ({ data }) => {
          // eslint-disable-next-line
          if (data.data.topic_source) {
            this.state.ketilaiyuan = true;
          }
          if (data.code !== 0) {
            this.setState({
              phone: data.data.phone,
            });
          }
        }
      );
    }
  }

  render() {
    return (
      <div>
        <Header phone={this.state.phone}></Header>
        <div style={{ alignItems: "center" }}>
          <div className={styles.tabs}>
            <div className={styles.itemMain}>
              <Link to="/yuyue" className={styles.link}>
                <Item text="我要送检" img="我要送检.png"></Item>
              </Link>
              <Link to="/OrderList" className={styles.link}>
                <Item text="服务单" img="送样单.png"></Item>
              </Link>
            </div>
          </div>

          <div className={styles.mainV}>
            <div className={styles.main}>
              <Link to="/">
                <Line leftText={"实验室微官网"}></Line>
              </Link>
              <Link to="/contact">
                <Line leftText={"联系我们"}></Line>
              </Link>
              <Link to="/test_know">
                <Line leftText={"送检须知"}></Line>
              </Link>
              <Link to="/share">
                <Line leftText={"分享实验室"}></Line>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/My.js